import React from 'react';
import {Link} from 'react-router-dom';
import { Container } from 'reactstrap';

import AdminGameList from '../Games/AdminGameList';
import AdminUserList from '../Users/AdminUserList';

import { Button, TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';


class AdminDashboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: '1'
        };
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
    }

    render(){
        return (
            <div>
                <Container className='mt3'>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            onClick={() => { this.toggle('1'); }}
                            >
                            Games
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            onClick={() => { this.toggle('2'); }}
                            >
                            Users
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                            <Row className="mt2">
                                <Col sm="12">
                                    <Link to='/admin/add-game'>
                                        <Button className="mb1" color='primary'>
                                        Add Game
                                        </Button>
                                    </Link>
                                    <AdminGameList />
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="2">
                            <Row className="mt2">
                                <Col sm="12">
                                    <AdminUserList />
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>
                </Container>
            </div>
        );
    }
}

export default AdminDashboard;


// WEBPACK FOOTER //
// ./src/components/Admin/Dashboard/AdminDashboard.js